import dayjs from 'dayjs';

export interface DateRange {
  start: string;
  end: string;
}

export function formatDateRange(start: string, end: string): string {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const sameYear = startDate.year() === endDate.year();
  const startFmt = sameYear ? startDate.format('MMM DD') : startDate.format('MMM DD, YYYY');
  const endFmt = endDate.format('MMM DD, YYYY');
  return `${startFmt} - ${endFmt}`;
}

export function getWeekForDate(date: string): DateRange {
  const d = dayjs(date);
  const dow = d.day(); // 0=Sun, 1=Mon, ..., 6=Sat
  const monday = d.subtract(dow === 0 ? 6 : dow - 1, 'day');
  const sunday = monday.add(6, 'day');
  return {
    start: monday.format('YYYY-MM-DD'),
    end: sunday.format('YYYY-MM-DD'),
  };
}

export function getDateRangeShortcut(shortcut: string): DateRange {
  const today = dayjs();

  switch (shortcut) {
    case 'today':
      return { start: today.format('YYYY-MM-DD'), end: today.format('YYYY-MM-DD') };

    case 'yesterday': {
      const yesterday = today.subtract(1, 'day');
      return { start: yesterday.format('YYYY-MM-DD'), end: yesterday.format('YYYY-MM-DD') };
    }

    case 'thisWeek': {
      const dow = today.day();
      const monday = today.subtract(dow === 0 ? 6 : dow - 1, 'day');
      const sunday = monday.add(6, 'day');
      return { start: monday.format('YYYY-MM-DD'), end: sunday.format('YYYY-MM-DD') };
    }

    case 'lastWeek': {
      const dow = today.day();
      const thisMonday = today.subtract(dow === 0 ? 6 : dow - 1, 'day');
      const lastMonday = thisMonday.subtract(7, 'day');
      const lastSunday = lastMonday.add(6, 'day');
      return { start: lastMonday.format('YYYY-MM-DD'), end: lastSunday.format('YYYY-MM-DD') };
    }

    case 'lastTwoWeeks': {
      const dow = today.day();
      const thisMonday = today.subtract(dow === 0 ? 6 : dow - 1, 'day');
      const twoWeeksAgoMonday = thisMonday.subtract(14, 'day');
      const lastSunday = thisMonday.subtract(1, 'day');
      return {
        start: twoWeeksAgoMonday.format('YYYY-MM-DD'),
        end: lastSunday.format('YYYY-MM-DD'),
      };
    }

    case 'thisMonth':
      return {
        start: today.startOf('month').format('YYYY-MM-DD'),
        end: today.endOf('month').format('YYYY-MM-DD'),
      };

    case 'lastMonth': {
      const lastMonth = today.subtract(1, 'month');
      return {
        start: lastMonth.startOf('month').format('YYYY-MM-DD'),
        end: lastMonth.endOf('month').format('YYYY-MM-DD'),
      };
    }

    case 'thisYear':
      return {
        start: today.startOf('year').format('YYYY-MM-DD'),
        end: today.endOf('year').format('YYYY-MM-DD'),
      };

    case 'lastYear': {
      const lastYear = today.subtract(1, 'year');
      return {
        start: lastYear.startOf('year').format('YYYY-MM-DD'),
        end: lastYear.endOf('year').format('YYYY-MM-DD'),
      };
    }

    default:
      return { start: today.format('YYYY-MM-DD'), end: today.format('YYYY-MM-DD') };
  }
}
